import { ticketClient } from "@/api/index";
import { GetWorkerRepayDetailReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
// lee 绩效接口参数
interface Options {
  OrderId: string;
  pageIndex: number;
  pageSize: number;
  rank: number;
  itemId: string | number;
  Userid: number; // 用户id
  sort?: number;
  Statssort: number; // 排序
  Statstype: number;
  Timerange: string;
}
export function getRepayPrincipal(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetWorkerRepayDetailReq();
      request.setCommonin(setCommon());
      request.setTicketitemid(arg.itemId); // 工单 id 
      request.setAdminuid(arg.Userid); // 用户id
      request.setStatsdate(arg.Timerange); // 用户id
      // request.setStatssort(arg.Statssort); // 排序
      // request.setStatstype(arg.Statstype);
      // request.setPagein(
      //   setPage(arg.pageIndex, arg.pageSize, arg.sort, arg.rank)
      // );
      // setRank
      let _res = await ticketClient.getWorkerRepayDetail(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function exportRepayPrincipal(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetWorkerRepayDetailReq();
      request.setCommonin(setCommon());
      request.setTicketitemid(arg.itemId); // 工单 id 
      request.setAdminuid(arg.Userid); // 用户id
      request.setStatsdate(arg.Timerange); // 用户id
      // request.setStatssort(arg.Statssort); // 排序
      // request.setStatstype(arg.Statstype);
      // request.setPagein(
      //   setPage(arg.pageIndex, arg.pageSize, arg.sort, arg.rank)
      // );
      // setRank
      let _res = await ticketClient.getWorkerRepayDetailExcel(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
